import metalpass from './metalpass.jpg'
import fnc from './fnc.png'
import dashMetalpass0 from './dash-metalpass/0.png'
import dashMetalpass1 from './dash-metalpass/1.png'
import dashMetalpass2 from './dash-metalpass/2.png'
import dashMetalpass3 from './dash-metalpass/3.png'
import dashMetalpass4 from './dash-metalpass/4.png'
import dashMetalpass5 from './dash-metalpass/5.png'
import chaoticTracker0 from './chaotic-tracker/0.png'
import chaoticTracker1 from './chaotic-tracker/1.png'
import visity0 from './visity/0.png'
import visity1 from './visity/1.png'
import visity2 from './visity/2.png'
import visity3 from './visity/3.png'
import gabi0 from './gabi/0.png'
import gabi1 from './gabi/1.png'
import gabi2 from './gabi/2.png'
import gabi3 from './gabi/3.png'
import gabi4 from './gabi/4.png'
import gabi5 from './gabi/5.png'
import gabi6 from './gabi/6.png'
import gabi7 from './gabi/7.png'
import gabi8 from './gabi/8.png'
import gabi9 from './gabi/9.png'
import gabi10 from './gabi/10.png'
import gabi11 from './gabi/11.png'
import gabi12 from './gabi/12.png'
import gabi13 from './gabi/13.png'
import gabi14 from './gabi/14.png'
import gabi15 from './gabi/15.png'
import edupop0 from './edupop/0.png'
import edupop1 from './edupop/1.png'
import edupop2 from './edupop/2.png'
import edupop3 from './edupop/3.png'
import edupop4 from './edupop/4.png'
import edupop5 from './edupop/5.png'
import ox3Web0 from './ox3-web/0.png'
import ox3Web1 from './ox3-web/1.png'
import ox3Web2 from './ox3-web/2.png'
import ox3Web3 from './ox3-web/3.png'
import ox3Web4 from './ox3-web/4.png'
import ox3Web5 from './ox3-web/5.png'
import ox3Web6 from './ox3-web/6.png'
import ox3Web7 from './ox3-web/7.png'
import ox3Web8 from './ox3-web/8.png'
import ox3Web9 from './ox3-web/9.png'
import ox3App0 from './ox3-app/0.png'
import ox3App1 from './ox3-app/1.png'
import ox3App2 from './ox3-app/2.png'
import ox3App3 from './ox3-app/3.png'
import ox3App4 from './ox3-app/4.png'
import ox3App5 from './ox3-app/5.png'
import easyHouse0 from './easy-house/0.png'
import easyHouse1 from './easy-house/1.png'
import easyHouse2 from './easy-house/2.png'
import easyHouse3 from './easy-house/3.png'
import easyHouse4 from './easy-house/4.png'
import easyHouse5 from './easy-house/5.png'
import easyHouse6 from './easy-house/6.png'
import easyHouse7 from './easy-house/7.png'
import easyHouse8 from './easy-house/8.png'
import easyHouse9 from './easy-house/9.png'
import easyHouse10 from './easy-house/10.png'
import easyHouse11 from './easy-house/11.png'

const assets = {
    metalpass,
    fnc,
    dashMetalpass: [
        dashMetalpass0,
        dashMetalpass1,
        dashMetalpass2,
        dashMetalpass3,
        dashMetalpass4,
        dashMetalpass5
    ],
    chaoticTracker: [
        chaoticTracker0,
        chaoticTracker1
    ],
    visity: [
        visity0,
        visity1,
        visity2,
        visity3
    ],
    ox3Web: [
        ox3Web0,
        ox3Web1,
        ox3Web2,
        ox3Web3,
        ox3Web4,
        ox3Web5,
        ox3Web6,
        ox3Web7,
        ox3Web8,
        ox3Web9,
    ],
    ox3App: [
        ox3App0,
        ox3App1,
        ox3App2,
        ox3App3,
        ox3App4,
        ox3App5,
    ],
    easyHouse: [
        easyHouse0,
        easyHouse1,
        easyHouse2,
        easyHouse3,
        easyHouse4,
        easyHouse5,
        easyHouse6,
        easyHouse7,
        easyHouse8,
        easyHouse9,
        easyHouse10,
        easyHouse11,
    ],
    edupop: [
        edupop0,
        edupop1,
        edupop2,
        edupop3,
        edupop4,
        edupop5,
    ],
    gabi: [
        gabi0,
        gabi1,
        gabi2,
        gabi3,
        gabi4,
        gabi5,
        gabi6,
        gabi7,
        gabi8,
        gabi9,
        gabi10,
        gabi11,
        gabi12,
        gabi13,
        gabi14,
        gabi15,
    ]
}

export default assets